import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";

import "./blog.css";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../../components/SelectButton";
import download from "../../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../../components/ReactTable";
import { BsPlusSquare } from "react-icons/bs";
import editBond from "../../../assets/editBond.png";
import delBond from "../../../assets/deleteBond.png";
import CustomPagination from "../../../components/CustomPagination";
import leftIcon from "../../../assets/Left Icons.png";
import axios from "axios";
import ReusableModal from "./ResuableModel";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  statusSuccess: 'blog-status-success-toast',
  statusError: 'blog-status-error-toast',
  addSuccess: 'blog-add-success-toast',
  addError: 'blog-add-error-toast',
  validationError: 'blog-validation-error-toast'
};

function UserManagementMain() {
  const navigate = useNavigate();
  const [blogsData, setBlogsData] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('blogPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);
  const [editBlog, setEditBlog] = useState({
    heading: "",
    body: "",
    thumbnail: "",
    author: "",
    designation: "",
  });
  const [error, setError] = useState(null);
  const [heading, setheading] = useState("");
  const [body, setText] = useState("");
  const [author, setAuthor] = useState("");
  const [designation, setDesignation] = useState("");
  const [thumbnail, setThumbnail] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

  // Add new state for tracking submission status
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Function to update multiple values

  const extractFileName = (filePath) => {
    if (!filePath) return "No Thumbnail";
    const parts = filePath.split("/");
    return parts[parts.length - 1]; // Extract the file name from the path
  };

  const updateRole = (newValues) => {
    setEditBlog((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
      thumbnail: extractFileName(newValues.thumbnail),
    }));
    setheading(newValues.heading);
    setText(newValues.body);
    console.log("heading", newValues?.body);
    setThumbnail(newValues.thumbnail);
    setAuthor(newValues.author);
    setDesignation(newValues.designation);
    setIsModalOpenEdit(true);
  };

  const columnHelper = createColumnHelper();

  const handleCancel = () => {
    // Reset form fields
    setheading("");
    setText("");
    setThumbnail(null);
    setDesignation("");
    setAuthor("");
  };

  const fetchBlogdata = async () => {
    const endpoint = `${base_url}/${api_type}/cms/blogs`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        params: {
          page: page,  // Add this to send the page number to the API
          perPage: 10  // Add this if you want to control items per page
        }
      });

      setBlogsData(response?.data?.data?.blogs);
      setTotal(response?.data?.data?.totalRecords);
      // Don't set the page here as it will cause a loop
      // setPage(response?.data?.data?.currentPage);
      
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      setError(err.message);
    }
  };

  // Update useEffect to depend on page changes
  useEffect(() => {
    fetchBlogdata();
  }, [page]); // Add page as a dependency

  const openModal = () => {
    // Reset form fields for adding a new blog
    setheading("");
    setText("");
    setThumbnail(null);
    setAuthor("");
    setDesignation("");
    setIsModalOpen(true);
  };
  // const closeModal = () => setIsModalOpen(false) ; // Function to close modal
  const closeModalEdit = () => setIsModalOpenEdit(false); // Function to close modal

  const closeModal = () => {
    setIsModalOpen(false);
    handleCancel();
  };
  const toggleStatus = async (id) => {
    console.log("did", id);

    const endpoint = `${base_url}/${api_type}/cms/blogs/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      if (!toast.isActive(toastIds.statusSuccess)) {
        toast.success("Status Updated", {
          toastId: toastIds.statusSuccess,
          autoClose: 3000
        });
      }
      fetchBlogdata();
    } catch (err) {
      if (!toast.isActive(toastIds.statusError)) {
        toast.error(err?.response?.data.message || "Failed to update status", {
          toastId: toastIds.statusError,
          autoClose: 3000
        });
      }
      console.error("Failed to update status:", err);
      setError(err.message);
    }
  };

  const addNewBlog = async (type) => {
    // Prevent multiple submissions
    if (isSubmitting) return;

    const endpoint = `${base_url}/${api_type}/cms/blogs`;
    const endpointEdit = `${base_url}/${api_type}/cms/blogs/${editBlog?.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    let isError = false;

    // Separate validation for edit and new blog
    if (type === "edit") {
      // Validation for edit mode
      if (!editBlog?.heading?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Heading cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!editBlog?.body?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Body cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!editBlog?.author?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Author cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!editBlog?.designation?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Designation cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }
    } else {
      // Validation for new blog
      if (!heading?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Heading cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!body?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Body cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!author?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Author cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!designation?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Designation cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }

      if (!thumbnail) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Image file cannot be empty.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }
    }

    try {
      setIsSubmitting(true); // Set submitting state to true

      const editFormData = new FormData();
      editFormData.append("heading", editBlog?.heading);
      editFormData.append("body", editBlog?.body);
      if (editBlog?.thumbnail instanceof File) {
        editFormData.append("file", editBlog?.thumbnail);
      }
      editFormData.append("author", editBlog?.author);
      editFormData.append("designation", editBlog?.designation);

      const AddNewFormData = new FormData();
      AddNewFormData.append("heading", heading);
      AddNewFormData.append("body", body);
      AddNewFormData.append("file", thumbnail);
      AddNewFormData.append("author", author);
      AddNewFormData.append("designation", designation);
      const response =
        type === "edit"
          ? await axios.put(endpointEdit, editFormData, {
              headers: {
                ...headers,
                "Content-Type": "multipart/form-data",
              },
            })
          : await axios.post(endpoint, AddNewFormData, {
              headers: {
                ...headers,
                "Content-Type": "multipart/form-data",
              },
            });

      // Reset input fields and states

      setheading("");
      setText("");
      setAuthor("");
      setDesignation("");
      setThumbnail(null);

      console.log("Blog response", response);
      if (!toast.isActive(toastIds.addSuccess)) {
        toast.success(type === "edit" ? "Blog Updated Successfully" : "New Blog Added", {
          toastId: toastIds.addSuccess,
          autoClose: 3000
        });
      }
      fetchBlogdata();
      setIsModalOpen(false);
      setIsModalOpenEdit(false);

      setIsSubmitting(false); // Reset submitting state on success
    } catch (err) {
      setIsSubmitting(false); // Reset submitting state on error
      console.error("Error:", err);
      if (!toast.isActive(toastIds.addError)) {
        toast.error(err?.response?.data?.message || "Failed to add blog", {
          toastId: toastIds.addError,
          autoClose: 3000
        });
      }
      setError(err?.message || "An error occurred");
    }
  };

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  function renderValue(text) {
    const words = text?.split(" ");
    if (words?.length > 30) {
      return words?.slice(0, 30).join(" ") + " ....";
    }
    return text;
  }

  const stripHtmlforEdit = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    columnHelper.accessor("heading", {
      cell: (info) => info.renderValue(),
      header: () => <span>Heading</span>,
    }),
    columnHelper.accessor("body", {
      cell: (info) => (
        <>
          <style>
            {`
            ul, ol {
              margin: 0;
              padding-left: 20px;
              list-style: disc; /* Ensure bullet points */
            }
            ol {
              list-style: decimal; /* Ensure ordered list numbers */
            }
            li {
              margin-bottom: 5px;
            }
          `}
          </style>
          <div
            dangerouslySetInnerHTML={{
              __html: renderValue(info.renderValue()),
            }}
          />
        </>
      ),
      header: () => <span>Body Text</span>,
    }),
    columnHelper.accessor("thumbnail", {
      cell: (info) => info.renderValue(),
      header: () => <span>Thumbnailed</span>,
    }),
    columnHelper.accessor("author", {
      cell: (info) => info.renderValue(),
      header: () => <span>Author</span>,
    }),
    columnHelper.accessor("designation", {
      cell: (info) => info.renderValue(),
      header: () => <span>Designation</span>,
    }),
    columnHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;

        console.log("info", info?.row?.original);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm`}
          >
            {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
            <ToggleButton
              value={status}
              handleToggleStatus={toggleStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("blogI", uniqueId);
        console.log("new", info?.row?.original?.body);
        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  updateRole({
                    id: uniqueId,
                    heading: info.row.original.heading,
                    body: info.row.original.body,
                    thumbnail: info.row.original.thumbnail,
                    author: info.row.original.author,
                    designation: info.row.original.designation,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this blog?")) {
                  axios.delete(`${base_url}/${api_type}/cms/blogs/${uniqueId}`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Blog deleted successfully");
                    fetchBlogdata();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete blog");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  console.log("body..", editBlog?.body);
  return (
    <div className=" mt-[60px] px-4">
      <div className="bg-white px-8  mt-4 rounded-[10px] border">
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 py-4 gap-y-4">
            <div className="flex gap-2">
              <div class="flex gap-0.5">
                <h1 className="text-[#252C32] text-[20px] font-bold">Blog </h1>
              </div>
            </div>
            {userPermissionData?.user?.addRole && (
              <div class="flex items-center bg-[#035C98]  rounded-[8px]">
                <button
                  class="btn flex items-center gap-2 text-white font-bold"
                  onClick={openModal}
                >
                  <BsPlusSquare size={18} className="mt-px" />
                  Add New
                </button>
              </div>
            )}
            {/* Modal Component */}
            {isModalOpen && (
              <ReusableModal
                content={
                  <div className="w-full max-w-md mx-auto my-auto bg-white ">
                    <h2 className="text-center text-[24px] font-semibold mb-4">
                      Add Blog
                    </h2>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                      Heading
                    </label>
                    <div className="flex mt-2 mb-4">
                      <input
                        type="text"
                        value={heading}
                        placeholder="type here"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                        onChange={(e) => setheading(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Body Text
                      </label>
                      <div
                        style={{
                          // border: "1px solid #ccc",
                          padding: "10px",
                          marginTop: "10px",
                          lineHeight: "1.6",
                        }}
                      >
                        <style>
                          {`
                                              ul, ol {
                                                margin: 0;
                                                padding-left: 20px;
                                                list-style: disc; /* Ensure bullet points */
                                              }
                                              ol {
                                                list-style: decimal; /* Ensure ordered list numbers */
                                              }
                                              li {
                                                margin-bottom: 5px;
                                              }
                                            `}
                        </style>
                        <CKEditor
                          editor={ClassicEditor}
                          value={body}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            const plainText = stripHtml(data);
                            console.log("Extracted Text:", plainText); // Debugging log
                            setText(plainText); // Set only the plain text value
                          }}
                          config={{
                            licenseKey: "GPL", // Use the GPL license.
                            plugins: [
                              Essentials,
                              Paragraph,
                              Bold,
                              Italic,
                              Heading,
                              Link,
                              List,
                              BlockQuote,
                              Image,
                              // Table,
                              MediaEmbed,
                              PasteFromOffice,
                              Font,
                              Alignment,
                            ],
                            toolbar: [
                              "heading",
                              "|",
                              "bold",
                              "italic",
                              "link",
                              "|",
                              "bulletedList",
                              "numberedList",
                              "|",
                              "blockQuote",
                              "insertTable",
                              "|",
                              "undo",
                              "redo",
                              "|",
                              "alignment:left",
                              "alignment:center",
                              "alignment:right",
                              "alignment:justify",
                              "|",
                              "fontColor",
                              "fontBackgroundColor",
                              "fontSize",
                              "|",
                              // "mediaEmbed",
                            ],
                          }}
                        />
                      </div>
                    </div>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                      Upload Thumbnail
                    </label>
                    <div className="flex items-center mt-2 mb-4 relative">
                      <input
                        type="file"
                        id="thumbnailUpload"
                        accept="image/*"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            setThumbnail(e.target.files[0]); // Update the file state
                          }
                        }}
                      />
                      <div className="flex items-center w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]">
                        <span className="text-gray-500 flex-grow">
                          {thumbnail ? thumbnail.name : "Add file"}{" "}
                          {/* Show the file name if a file is selected */}
                        </span>
                        <img
                          src={leftIcon}
                          className="h-[30px] w-[30px] cursor-pointer"
                          alt="upload"
                        />
                      </div>
                    </div>

                    <div className="flex">
                      <div className="">
                        <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                          Author
                        </label>
                        <div className="flex mt-2">
                          <input
                            type="text"
                            value={author}
                            placeholder="type here"
                            className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                            onChange={(e) => setAuthor(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="pl-3">
                        <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                          Designation
                        </label>
                        <div className="flex mt-2">
                          <input
                            type="text"
                            value={designation}
                            placeholder="type here"
                            className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                            onChange={(e) => setDesignation(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                onUpload={() => addNewBlog("new")}
                ButtonValue="Add"
                onClose={closeModal}
                isDisabled={isSubmitting}
              />
            )}
            {isModalOpenEdit && (
              <ReusableModal
                content={
                  <div className="w-full max-w-md mx-auto my-auto bg-white ">
                    <h2 className="text-center text-[24px] font-semibold mb-4">
                      Edit Blog
                    </h2>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                      Heading
                    </label>
                    <div className="flex mt-2 mb-4">
                      <input
                        type="text"
                        value={editBlog?.heading || ""}
                        placeholder="Type heading here"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                        onChange={(e) =>
                          setEditBlog((prevState) => ({
                            ...prevState,
                            heading: e.target.value, // Update heading in the editBlog state
                          }))
                        }
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Body Text
                      </label>
                      <div
                        style={{
                          padding: "10px",
                          marginTop: "10px",
                          lineHeight: "1.6",
                        }}
                      >
                        <style>
                          {`
        ul, ol {
          margin: 0;
          padding-left: 20px;
          list-style: disc; /* Ensure bullet points */
        }
        ol {
          list-style: decimal; /* Ensure ordered list numbers */
        }
        li {
          margin-bottom: 5px;
        }
      `}
                        </style>
                        <CKEditor
                          editor={ClassicEditor}
                          data={editBlog?.body || ""} // Use the `data` prop for prefilled value
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            // const plainText = stripHtml(data);
                            // Full editor content
                            setEditBlog((prevState) => ({
                              ...prevState,
                              body: data, // Keep the HTML content here
                            }));
                          }}
                          config={{
                            licenseKey: "GPL",
                            plugins: [
                              Essentials,
                              Paragraph,
                              Bold,
                              Italic,
                              Heading,
                              Link,
                              List,
                              BlockQuote,
                              MediaEmbed,
                              PasteFromOffice,
                              Font,
                              Alignment,
                            ],
                            toolbar: [
                              "heading",
                              "|",
                              "bold",
                              "italic",
                              "link",
                              "|",
                              "bulletedList",
                              "numberedList",
                              "|",
                              "blockQuote",
                              "|",
                              "undo",
                              "redo",
                              "|",
                              "alignment:left",
                              "alignment:center",
                              "alignment:right",
                              "alignment:justify",
                              "|",
                              "fontColor",
                              "fontBackgroundColor",
                              "fontSize",
                            ],
                            language: "en", // Set language to English
                            alignment: {
                              options: ["left", "center", "right", "justify"],
                            },
                            typing: {
                              direction: "ltr", // Force Left-to-Right
                            },
                          }}
                        />
                      </div>
                    </div>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                      Upload Thumbnail
                    </label>
                    <div className="flex items-center mt-2 mb-4 relative">
                      <input
                        type="file"
                        id="thumbnailUpload"
                        accept="image/*"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            setEditBlog((prevState) => ({
                              ...prevState,
                              thumbnail: e.target.files[0], // Update file in editBlog state
                            }));
                          }
                        }}
                      />
                      <div className="flex items-center w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]">
                        <span className="text-gray-500 flex-grow">
                          {editBlog.thumbnail
                            ? editBlog.thumbnail.name || editBlog.thumbnail
                            : "Add file"}
                          {/* Display the file name if a file is selected or pre-filled */}
                        </span>
                        <img
                          src={leftIcon}
                          className="h-[30px] w-[30px] cursor-pointer"
                          alt="upload"
                        />
                      </div>
                    </div>

                    <div className="flex">
                      <div>
                        <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                          Author
                        </label>
                        <div className="flex mt-2">
                          <input
                            type="text"
                            value={editBlog?.author || ""}
                            placeholder="Type author here"
                            className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                            onChange={(e) =>
                              setEditBlog((prevState) => ({
                                ...prevState,
                                author: e.target.value, // Update author in the editBlog state
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="pl-3">
                        <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                          Designation
                        </label>
                        <div className="flex mt-2">
                          <input
                            type="text"
                            value={editBlog?.designation || ""}
                            placeholder="Type designation here"
                            className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                            onChange={(e) =>
                              setEditBlog((prevState) => ({
                                ...prevState,
                                designation: e.target.value, // Update designation in the editBlog state
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                onUpload={() => addNewBlog("edit")}
                ButtonValue="Update"
                onClose={closeModalEdit}
                isDisabled={isSubmitting}
              />
            )}
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        <ReactTable
          key={JSON.stringify(blogsData)}
          defaultData={blogsData || []}
          columns={columns}
        />
      </div>

      {blogsData?.length > 0 && (
        <div className="w-auto">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
            storageKey="blogPage"
          />
        </div>
      )}
    </div>
  );
}

export default UserManagementMain;
